import { clearStorage, removeSessionItem, storageKeys } from "../../shared/storage/index";

export function deleteLocalAccount({ logout, navigate }) {
  const confirmed = window.confirm(
    "Delete your account? This removes your local profile and signs you out.",
  );
  if (!confirmed) return;

  clearStorage();
  removeSessionItem(storageKeys.user);
  removeSessionItem(storageKeys.role);
  logout();
  navigate("/");
}
